module.exports = __webpack_public_path__ + "img/default_verify.6b914f9c.jpg";